import React, { memo } from "react";
import * as PR from "../../../prime-modules/index";
import ChartDataLabels from "chartjs-plugin-datalabels";
import countries from "i18n-iso-countries";

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

const ActiveSubscriptionGraph = (data) => {

  const bundles = Array.isArray(data?.activeSubscription?.values) ? data?.activeSubscription?.values : [];

  const labels = bundles?.map((item) => item.xValue);
  const values = bundles?.map((item) => item.yValue);

  const barThicknessValue = bundles.length <= 4 ? 30 : "flex";

  const barChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        bottom: 20,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: "#fff",
        anchor: "end",
        align: "top",
        font: {
          weight: "bold",
        },
        formatter: Math.round,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 0,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        ticks: {
          stepSize: 5,
          precision: 0,
        },
      },
    },
  };

  const chartData = {
    labels,
    datasets: [
      {
        label: "Subscription Count",
        data: values,
        backgroundColor: "#003366",
        barThickness: barThicknessValue,
        maxBarThickness: 50,
      },
    ],
  };

  return (
    <div className="mt-4">
      <PR.Chart
        type="bar"
        data={chartData}
        plugins={[ChartDataLabels]}
        options={barChartOptions}
        style={{height:"360px"}}
      />
    </div>
  );
};


export default memo(ActiveSubscriptionGraph);
